module.exports = __webpack_public_path__ + "static/media/huli_201.afe3044e.gif";